import { computePosition, shift, offset, arrow, autoPlacement } from '@floating-ui/dom'

export default class Tooltip {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Tooltip.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.$title = this.DOM.$el.title
        this.timeout = () => { }
        this.buildTooltip()
        this.update()

        // Define the events to show and hide the tooltip
        this.DOM.$el.addEventListener('mouseenter', this.show.bind(this), { passive: true })
        this.DOM.$el.addEventListener('mouseleave', this.hide.bind(this), { passive: true })
        this.DOM.$el.addEventListener('focus', this.show.bind(this), { passive: true })
        this.DOM.$el.addEventListener('blur', this.hide.bind(this), { passive: true })

        document.body.addEventListener('tooltip:hide', this.hide.bind(this), false)
    }

    buildTooltip() {
        // Create the tooltip with the defined content
        let $contentElement = document.querySelector('#' + this.DOM.$el.dataset[this.options.dataAttrContentElementId])
        if ($contentElement) {
            this.DOM.$tooltip = $contentElement
        } else {
            this.DOM.$tooltip = document.createElement('div')
        }
        this.DOM.$tooltip.classList.add(this.options.classNameTooltip)
        this.DOM.$tooltip.innerHTML = this.getContent()

        // Create the arrow
        this.DOM.$arrow = document.createElement('div')
        this.DOM.$arrow.classList.add(this.options.classNameArrow)
        this.DOM.$tooltip.appendChild(this.DOM.$arrow)

        // Insert the tooltip at the end of the body
        document.body.appendChild(this.DOM.$tooltip)
    }

    getContent() {
        let $contentElement = document.querySelector('#' + this.DOM.$el.dataset[this.options.dataAttrContentElementId])
        if ($contentElement) {
            let $content = $contentElement.innerHTML
            $contentElement.innerHTML = ''
            return $content

        }
        return this.$title
    }

    update() {
        computePosition(this.DOM.$el, this.DOM.$tooltip, {
            middleware: [
                offset(6),
                autoPlacement({ allowedPlacements: ['top-start', 'bottom-start'], }),
                shift(),
                arrow({ element: this.DOM.$arrow }),
            ],
        }).then(({ x, y, placement, middlewareData }) => {
            Object.assign(this.DOM.$tooltip.style, {
                left: `${x}px`,
                top: `${y}px`,
            })

            //--- Arrow positioning
            const { x: arrowX, y: arrowY } = middlewareData.arrow;

            let { left, right } = ''
            let arrowAlign = this.DOM.$el.dataset[this.options.dataAttrArrowAlign]

            if (arrowAlign === 'left') {
                left = '20px'
            } else if (arrowAlign === 'right') {
                right = '20px'
            } else {
                left = arrowX != null ? `${arrowX}px` : ''
            }

            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[placement.split('-')[0]];

            Object.assign(this.DOM.$arrow.style, {
                left: left,
                top: arrowY != null ? `${arrowY}px` : '',
                right: right,
                bottom: '',
                [staticSide]: '-4px',
            });
            //--- End of arrow positioning
        })
    }

    show() {
        this.timeout = setTimeout(() => {
            this.DOM.$el.title = ''
            this.DOM.$tooltip.style.display = 'block'
            this.DOM.$tooltip.style.visibility = 'visible'
            this.update()
        }, 250)
    }

    hide() {
        clearTimeout(this.timeout);
        this.DOM.$tooltip.style.display = 'none'
        this.DOM.$tooltip.style.visibility = 'hidden'
        this.DOM.$el.title = this.$title
    }
}

Tooltip.prototype.defaults = {
    classNameTooltip: 'c-tooltip',
    classNameArrow: 'c-arrow',
    dataAttrContent: 'tooltipContent',
    dataAttrArrowAlign: 'tooltipArrowAlign',
    dataAttrContentElementId: 'tooltipContentElementId',
}